//
//
//
//
//
//
//
//
//
//
//
import anchorMarketList from "./anchorMarketList";
import restrictionAnchorMarketList from "./restrictionAnchorMarketList";
export default {
  name: "anchorMarketManage",
  components: {
    restrictionAnchorMarketList: restrictionAnchorMarketList,
    anchorMarketList: anchorMarketList
  },
  mixins: [],
  data: function data() {
    return {
      activeIndex: 'anchorMarketList'
    };
  },
  created: function created() {},
  activated: function activated() {},
  methods: {
    handover: function handover(index) {
      this.activeIndex = index;
    }
  }
};